






















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { ChargeCustomerDetail } from '@/models/accounting/accountreceivable';
import { Utils } from '@/helper/utils';
import { Base } from '@/components/common/base';
import { getChargeCustomerHeaders } from '@/views/accounting/chargecustomer/chargeCustomer';
import { accountReceivableService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
  },
})
export default class CustomerChargeDetailsPage extends Base {
  public headers: VHeaders[] = getChargeCustomerHeaders(this);
  public selectedStore: string = '';
  public pagedChargeDetails: ChargeCustomerDetail[] = [];
  public loading: boolean = false;
  public customerNumber: string = '';
  public pagination = new PaginationModel('accountNumber');
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;
  public searched: boolean = false;
  public fetchFromServerLoading: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
      //this.$router.push({ name: 'app.customercharges' });
    } else if (methodName === 'syncManually') {
      this.fetchFromServer();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('customerChargeDetails.titleBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('customerChargeDetails.labelBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
      requestProgress: true,
    });
    buttons.push({
      id: '1',
      type: 'button',
      title: this.$t('customerChargeDetails.lblSync'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('customerChargeDetails.lblSync'),
      click: 'syncManually',
      icon: 'fas fa-sync-alt',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'customerCharges');
    
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.customerNumber = this.$route.query.customerNumber as string;

    this.getChargeCustomerDetails();
  }
  public async getChargeCustomerDetails(): Promise<void> {
    this.searched = true;
    try {
      this.loading = true;
      const response = await accountReceivableService.getChargeCustomerDetailsAsync(
        this.pagination,
        encodeURIComponent(this.customerNumber)
      );
      this.pagedChargeDetails = response.results;
      this.pagination.totalItems = response.total;
    } finally {
      this.loading = false;
    }
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: 'app.customercharges' });
    }
  }

  public updatePaging(paging): void {
    this.pagination = paging;
    this.getChargeCustomerDetails();
  }

  public async fetchFromServer(): Promise<void> {
    try {
      this.fetchFromServerLoading = true;
      this.$emit('update:progress', this.fetchFromServerLoading);
      await accountReceivableService.fetchDetailsFromServerAsync(
        encodeURIComponent(this.customerNumber)
      );
      this.showAlert(
        true,
        this.$t('customerChargeDetails.alertSyncInProgress')
      );
    } finally {
      this.fetchFromServerLoading = false;
      this.$emit('update:progress', this.fetchFromServerLoading);
    }
  }
}
